import {
  applyLocale,
  applyLocaleFromPreferred,
  DEFAULT_MARKET_COUNTRY,
  DEFAULT_MIVO_LOCALE,
  getIsMultiLanguageEnabled,
  normalizeMarketCountry,
  writeStoredMarketCountry,
} from "@mivo/i18n";

import type { IUser } from "@/domains/shared/models/IUser";

export function syncPreferredLocaleFromUser(user: IUser): IUser {
  if (!getIsMultiLanguageEnabled()) {
    void applyLocale(DEFAULT_MIVO_LOCALE);
    writeStoredMarketCountry(DEFAULT_MARKET_COUNTRY);
    return user;
  }

  applyLocaleFromPreferred(user.preferredLocale);
  writeStoredMarketCountry(normalizeMarketCountry(user.marketCountry));
  return user;
}
